import React from 'react';
import { Stack } from '@mantine/core';
import { AfaBreadcrumbs } from '../../ui/AfaBreadcrumbs/AfaBreadcrumbs';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';
import { Crumb } from '../../ui/AfaBreadcrumbs/AfaBreadcrumbs';

interface PageWithBreadcrumbsProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  onBreadcrumbNavigate?: (to: string) => boolean | Promise<boolean>;
}

/**
 * Wrapper component que añade breadcrumbs automáticos a cualquier página
 * Los breadcrumbs se generan automáticamente basándose en la configuración en breadcrumbConfig.ts
 * 
 * Uso:
 * <PageWithBreadcrumbs>
 *   <Title>Mi Página</Title>
 *   <div>Contenido...</div>
 * </PageWithBreadcrumbs>
 */
export function PageWithBreadcrumbs({
  children,
  className,
  style,
  onBreadcrumbNavigate,
}: PageWithBreadcrumbsProps) {
  const breadcrumbs = useBreadcrumbs();

  return (
    <Stack 
      gap="md" 
      {...(className && { className })}
      {...(style && { style })}
    >
      <AfaBreadcrumbs 
        items={breadcrumbs} 
        {...(onBreadcrumbNavigate && { onNavigate: onBreadcrumbNavigate })}
      />
      {children}
    </Stack>
  );
}